// 收视榜 / 荧幕CP / 追剧问答 / 观众热评（演示性策划内容）
export const overviewStats = [
  { label: "收录剧集", value: "128", unit: "部", icon: "ri-movie-2-line" },
  { label: "收录演员", value: "1,240", unit: "位", icon: "ri-user-star-line" },
  { label: "花絮条目", value: "860", unit: "条", icon: "ri-clapperboard-line" },
  { label: "每日更新", value: "24", unit: "H", icon: "ri-refresh-line" },
];

export const overviewCards = [
  {
    icon: "ri-list-check-2",
    title: "完整演员表",
    desc: "从男女主到配角、特别出演，逐条列出角色名与演员名，并标注一句话人物定位。",
  },
  {
    icon: "ri-user-heart-line",
    title: "主演档案",
    desc: "把演员的出道年份、经纪公司、代表作与戏外小料集中在一起，方便顺着角色往下了解本人。",
  },
  {
    icon: "ri-fire-line",
    title: "绯闻动态",
    desc: "以时间线形式跟进媒体报道与未证实传闻，标注可信度，帮你分辨哪些只是传闻。",
  },
  {
    icon: "ri-clapperboard-line",
    title: "幕后花絮",
    desc: "即兴台词、道具趣闻、通宵拍摄……把正片之外的故事单独成区，追剧之外也有得看。",
  },
];

export const ratingBoard = [
  { rank: 1, title: "四季食堂", rating: "14.1%", channel: "tvN 周末剧", trend: "持平", year: "2024" },
  { rank: 2, title: "首尔月台", rating: "12.4%", channel: "tvN 水木剧", trend: "上升", year: "2025" },
  { rank: 3, title: "黄金帝国", rating: "11.6%", channel: "SBS 月火剧", trend: "上升", year: "2025" },
  { rank: 4, title: "九号病房", rating: "10.2%", channel: "tvN 月火剧", trend: "新上榜", year: "2025" },
  { rank: 5, title: "汉江以北", rating: "9.8%", channel: "JTBC 金土剧", trend: "下降", year: "2025" },
  { rank: 6, title: "济州岛的雪", rating: "—", channel: "Netflix 原创", trend: "口碑榜", year: "2024" },
];

export const couples = [
  {
    id: "cp-1",
    drama: "首尔月台",
    pair: "尹夏琳 × 姜志勋",
    actors: "车瑞妍 × 李道勋",
    vote: 42,
    vibe: "遗憾美学 · 双向暗恋",
    line: "「末班车都开走了，你却还在站台上等我。」",
    image:
      "https://readdy.ai/api/search-image?query=Romantic%20cinematic%20scene%20of%20two%20people%20standing%20close%20on%20an%20empty%20train%20platform%20at%20dusk%2C%20warm%20amber%20lamp%20glow%2C%20soft%20rain%20and%20gentle%20bokeh%2C%20muted%20coral%20and%20cream%20palette%2C%20emotional%20editorial%20photography%2C%20tender%20longing%20mood&width=600&height=420&seq=hd-cp-01&orientation=landscape",
  },
  {
    id: "cp-2",
    drama: "四季食堂",
    pair: "吴夏恩 × 姜社长",
    actors: "金慕妍 × 权敏俊",
    vote: 27,
    vibe: "治愈系 · 细水长流",
    line: "「吃饭的时候不谈烦心事，这是我们家的规矩。」",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20cinematic%20scene%20of%20a%20warm%20neighborhood%20diner%20at%20night%2C%20two%20figures%20sharing%20a%20home%20cooked%20meal%20under%20hanging%20bulbs%2C%20steam%20rising%20from%20bowls%2C%20terracotta%20and%20cream%20tones%2C%20gentle%20editorial%20photography%2C%20comforting%20mood&width=600&height=420&seq=hd-cp-02&orientation=landscape",
  },
  {
    id: "cp-3",
    drama: "汉江以北",
    pair: "具本镇 × 申睿恩",
    actors: "郑宇彬 × 裴书俊",
    vote: 18,
    vibe: "并肩作战 · 非爱情向",
    line: "「我们查的不是案子，是被抹掉的那十年。」",
    image:
      "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20scene%20of%20two%20investigators%20standing%20side%20by%20side%20on%20a%20rainy%20city%20street%20at%20night%2C%20glowing%20street%20lamps%20on%20wet%20asphalt%2C%20deep%20charcoal%20and%20amber%20tones%2C%20moody%20editorial%20photography%2C%20tense%20partnership%20mood&width=600&height=420&seq=hd-cp-03&orientation=landscape",
  },
];

export const faqs = [
  {
    q: "韩剧TV的演员表在哪里看，包含哪些信息？",
    a: "本站把每部剧的演员表直接放在「热播剧演员表」分区。每张剧集卡片都会列出主要角色、对应演员，并用一句话标注该人物的定位（如「女一号 · 车站广播员」）。点击「展开全部主创」还能看到特别出演与配角。",
  },
  {
    q: "主演和配角、特别出演有什么区别？",
    a: "主演通常贯穿全剧、戏份最重，是宣传海报上的核心阵容；配角戏份次之但常推动关键剧情；特别出演则多为友情客串，戏份少但常常是亮点。本站会在演员表里用备注把三者区分开。",
  },
  {
    q: "页面里的明星绯闻都是真的吗？",
    a: "不是。绯闻时间线会明确标注可信度：写「已确认」的是有官方声明的消息；写「媒体报道」的是有媒体来源但双方未完全回应的消息；写「传闻」的则尚未证实。请把它当作线索，而不是定论。",
  },
  {
    q: "花絮一般包含什么内容？",
    a: "花絮分区聚焦「正片之外」：临场发挥的即兴台词、道具组的用心、通宵拍摄的幕后、演员之间的默契瞬间等。每条花絮都注明了所属剧集与主题类别，方便你按兴趣浏览。",
  },
  {
    q: "为什么有些剧没有收视率数字？",
    a: "收视率通常只适用于电视台播出的剧集。像 Netflix 等流媒体原创剧没有公开的收视百分比，本站会在这一栏标注「—」，并以「口碑榜」等方式另行说明，避免用不存在的数字充数。",
  },
];

export const reviews = [
  {
    id: "r1",
    user: "追剧不睡觉",
    avatar: "https://readdy.ai/api/search-image?query=Soft%20illustrated%20avatar%20of%20a%20friendly%20young%20woman%20with%20short%20hair%20and%20a%20cat%20%2C%20flat%20vector%20style%2C%20warm%20coral%20and%20cream%20palette%2C%20simple%20round%20badge%20background&width=120&height=120&seq=hd-user-01&orientation=squarish",
    time: "2 小时前",
    text: "《首尔月台》的演员表做得太细了，连站长的特别出演都标出来了。看完再回去追剧，感觉每个人物都立体了。",
    likes: 128,
  },
  {
    id: "r2",
    user: "橘子汽水",
    avatar: "https://readdy.ai/api/search-image?query=Soft%20illustrated%20avatar%20of%20a%20cheerful%20person%20holding%20a%20soda%20can%2C%20flat%20vector%20style%2C%20warm%20amber%20and%20cream%20palette%2C%20simple%20round%20badge%20background&width=120&height=120&seq=hd-user-02&orientation=squarish",
    time: "5 小时前",
    text: "最喜欢花絮那个区，原来那场戏是即兴的！导演不剪掉是对的，太真实了。希望能多更新《四季食堂》的幕后。",
    likes: 96,
  },
  {
    id: "r3",
    user: "冷面但爱哭",
    avatar: "https://readdy.ai/api/search-image?query=Soft%20illustrated%20avatar%20of%20a%20calm%20stylish%20person%20with%20glasses%2C%20flat%20vector%20style%2C%20muted%20terracotta%20and%20cream%20palette%2C%20simple%20round%20badge%20background&width=120&height=120&seq=hd-user-03&orientation=squarish",
    time: "昨天",
    text: "绯闻区标注可信度这个做法很加分，终于有人把「传闻」和「确认」分开了，不用再被标题党骗。",
    likes: 203,
  },
  {
    id: "r4",
    user: "木鱼脑壳",
    avatar: "https://readdy.ai/api/search-image?query=Soft%20illustrated%20avatar%20of%20a%20relaxed%20person%20in%20a%20hoodie%2C%20flat%20vector%20style%2C%20warm%20sand%20and%20cream%20palette%2C%20simple%20round%20badge%20background&width=120&height=120&seq=hd-user-04&orientation=squarish",
    time: "昨天",
    text: "按类型筛选演员表挺方便，想看悬疑就直接点「悬疑 / 犯罪」，不用一页页翻。就是希望以后能加上按演员筛选。",
    likes: 64,
  },
];